{
    "gatewaySelection": "Payment Gateway Selection",
    "request": "Request",
    "Configured": "Configured",
    "configureRequest": "Are you sure you want to send a configure request?",
    "SendRequest": "Send Request",
    "currencyConfiguration" : "Currency Configuration"
}